import Vue from 'vue'
import VueRouter from 'vue-router';
import App from './App.vue'
import router from './router'
import Ideas from './ideas';
import Colors from './colors';
import './scss/main.scss';

Vue.config.productionTip = false
Vue.use(VueRouter);
window.Vue = Vue;

Vue.prototype.$ideas = Ideas;
Vue.prototype.$colors = Colors;

new Vue({
  render: h => h(App),
  router,
  data(){
    return {
      textColor: this.$colors[0][1],
      bgColor: this.$colors[0][0]
    }
  },
  mounted(){
    this.$router.push(`/idea/`);
    this.randomizeColors();
  },
  methods: {
    randomizeColors(){
      let rndIndx = this.randomizeNum(0,9),
          rndOrder = this.randomizeNum(0,1);
      this.bgColor = this.$colors[rndIndx][rndOrder];
      if(rndOrder){
        this.textColor = this.$colors[rndIndx][0];
      }else {
        this.textColor = this.$colors[rndIndx][1];
      }
    },
    randomizeNum(min, max){
      return Math.floor(Math.random() * (max - min + 1)+min)
    }
  }
}).$mount('#app')
